import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";
import {checkPermission} from "../../../../../util/auth";
import {useParams} from "react-router-dom";

const UploadedMediaItemComponent = ({isPending = false,
                                      currentDeleteItem = '',
                                      image,
                                      deleteProduct,
                                      indexKey}) => {
  const errorHandle = (e) => {
    e.target.src = "/images/no-image.png"
  }
    const params = useParams();

    const disableStatus = ()=>{
        let status = true

        if(!checkPermission(['PRODUCT_UPDATE']) && params.id) {
            status = false
        }

        if(!checkPermission(['PRODUCT_CREATE']) && !params.id) {
            status = false
        }

        return status
    }

  return (
    <>
      <div className="inner">
        <div className="inner_wrap">
            {disableStatus() && <>
            {isPending && currentDeleteItem === indexKey ?
                <div className="remove_list opacity_1_important">
                    <button type="button" className="btn btn_black btn_xs">
                        <span className="false"><FontAwesomeIcon icon={faSpinner} spin/></span>
                    </button>
                </div> :
                <div className="remove_list">
                    <button type="button" className="btn btn_black btn_xs" onClick={() => {
                        deleteProduct(image, indexKey)
                    }}>
                        <span className="false"><i className="lni lni-close"></i></span>
                    </button>
                </div>
            }
            </>
            }
          <img src={image.url} onError={errorHandle} className={'width_full'} alt=""/>
        </div>
      </div>
    </>

  )
}

export default UploadedMediaItemComponent;